import React from 'react'
import { Empty as EmptyAnt } from 'antd'
import { EmptyProps } from 'antd/lib/empty'

import { useT } from 'src/core/hooks/use-translation'

function Empty({
  description = 'common.no-data',
  image,
  onlyText = false,
  ...props
}: EmptyProps & { onlyText?: boolean }) {
  const { t } = useT()

  return onlyText ? (
    t(description)
  ) : (
    <EmptyAnt
      description={t(description)}
      image={image || EmptyAnt.PRESENTED_IMAGE_SIMPLE}
      {...props}
    />
  )
}

export default Empty
